import {
  DetailedHTMLProps,
  ImgHTMLAttributes,
  useRef,
  useState,
  useEffect,
} from 'react'

import Cover1 from './cover1.svg'
import Cover2 from './cover2.svg'
import Cover3 from './cover3.svg'
import Cover4 from './cover4.svg'
import Cover5 from './cover5.svg'
import Cover6 from './cover6.svg'
import Cover7 from './cover7.svg'
import Cover8 from './cover8.svg'

const covers = [Cover1, Cover2, Cover3, Cover4, Cover5, Cover6, Cover7, Cover8]

export function ArticleCover({
  src,
  fetchPriority,
  ...props
}: DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> & {
  fetchPriority?: 'high' | 'low' | 'auto'
}) {
  const [isVisible, setIsVisible] = useState(false)
  const imgRef = useRef<HTMLImageElement>(null)

  const number = stringToNumber(props?.alt || props?.title || '')
  const randomImage = useRef(covers[number] ?? covers[0])

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
          observer.disconnect() // Stop observing once the image is visible
        }
      },
      { threshold: 0.05 }, // Trigger visibility when 5% of the image is visible
    )

    if (imgRef.current) observer.observe(imgRef.current)

    return () => {
      if (imgRef.current) observer.unobserve(imgRef.current)
    }
  }, [])

  return (
    <img
      {...props}
      ref={imgRef}
      src={src || randomImage.current.src}
      alt={props.alt || ''}
      fetchPriority={fetchPriority}
      loading={isVisible ? 'eager' : 'lazy'} // Use "lazy" until the image is in view
    />
  )
}

function stringToNumber(inputString: string): number {
  const hashValue = inputString.split('').reduce((a, b) => {
    a = (a << 5) - a + b.charCodeAt(0)
    return a & a
  }, 0)
  return Math.abs(hashValue % covers.length)
}
